module.exports = __webpack_public_path__ + "static/media/camera-alt.2bc34763.svg";